<script setup lang="ts">
  import type { ModifyCustomerInfoControllerExposed, RoutedCustomerViewComponentProps } from '@/types';
  import PageContent from '@/components/customerPage/pageContent/PageContent.vue';
  import { useI18n } from 'vue-i18n';
  import { computed, type UnwrapRef, useTemplateRef } from 'vue';
  import useAsyncComponentLoader from '@/composables/useAsyncComponentLoader.ts';

  defineOptions({ name: 'ModifyCustomerInfoView' });

  defineProps<RoutedCustomerViewComponentProps>();

  const controllerRef = useTemplateRef<UnwrapRef<ModifyCustomerInfoControllerExposed>>('controllerRef');
  const { t } = useI18n();
  const { getAsyncComponentWithLoader } = useAsyncComponentLoader();

  const ModifyCustomerInfoController = getAsyncComponentWithLoader(() => import('@/components/customerProfilePage/ModifyCustomerInfo/ModifyCustomerInfoFormController.vue'));

  const controllerIsSubmitting = computed<boolean>(() => {
    return controllerRef.value?.isSubmitting ?? false;
  });

</script>

<template>
  <PageContent :is-status-box-opened="isStatusBoxOpened">
    <template
      v-if="!controllerIsSubmitting"
      #header
    >
      <h1 class="md:container md:text-left">
        {{ t('pages.modifyCustomerInfo.title') }}
      </h1>
      <span class="md:container md:text-left text-sm aria-hidden before:content-['*'] before:mr-1 before:text-blue-accessible">{{ t('pages.modifyCustomerInfo.mandatoryFields') }}</span>
      <div class="flex flex-col gap-4 rounded border border-blue-accessible bg-blue-extra-light px-4 py-5 text-center md:container md:px-8 md:py-6">
        <p>{{ t('pages.modifyCustomerInfo.headerBox.content') }}</p>
      </div>
    </template>
    <ModifyCustomerInfoController ref="controllerRef" />
  </PageContent>
</template>
